import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"
import toast from 'react-hot-toast';
import { logout } from './userSlice';


export const initialState = {
  dashboard: {
    analytics: [],
    appointments: [],
  },
  reportStats: {
    total_requests: 0,
    covered_requests: 0,
    uncovered_requests: 0,
    avg_time_to_cover: 0,
  },
  vendorReliability: {
    data: [],
    total: 0,
    last_page: 1,
    current_page: 1,
    per_page: PAGELENGTH,
  },
  error: null,
  loader: false,
  featured: {},
  current_page: 1,
  per_page: PAGELENGTH,
  filters: null
}

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: initialState,
  reducers: {
    setDashboardAnalytic: (state, { payload }) => {
      state.dashboard = payload?.data ?? payload;
    },
    setDashboardAnalytics: (state, { payload }) => {
      state.dashboard.analytics = payload;
    },
    setDashboardAppointments: (state, { payload }) => {
      state.dashboard.appointments = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page
    },
    removerVendorReports: (state, { payload }) => {
      state.error = payload
    },
    clearAllDashboard: (state, { payload }) => {
      state.loader = payload
    },
    setReportStats: (state, { payload }) => {
      state.reportStats = payload;
    },
    setVendorReliability: (state, { payload }) => {
      state.vendorReliability = {
        data: payload?.data ?? [],
        total: payload?.total ?? 0,
        last_page: payload?.last_page ?? 1,
        current_page: payload?.current_page ?? 1,
        per_page: payload?.per_page ?? PAGELENGTH,
      };
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
    setDashboardFilters: (state, { payload }) => {
      state.filters = payload
    },
  }
})


export const fetchDashboardAnalytics = (params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchClientDashboardAnalytics(params)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setDashboardAnalytics(result.data.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
    else if (result?.status == 401) {
      dispatch(setError("Unauthorized"))
      dispatch(logout())
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}



export const fetchDashboardAppointments = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchClientDashboardAppointment(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setDashboardAppointments(result.data.data));
      } else {
        dispatch(setDashboardAppointments(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
    else if (result?.status == 401) {
      dispatch(setError("Unauthorized"))
      dispatch(logout())
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}



export const downloadDashboardAppointmentsCSV = (params) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const response = await Api.exportDashboardAppointments(params);
    if (response.status >= 200 && response.status < 300) {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `algovi_appointments_${new Date().toISOString().split("T")[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      toast.success("Report Downloaded Successfully", {
        className: "successToast",
      });
    } else {
      toast.error("Failed to download CSV", {
        className: "errorToast",
      });
    }
  } catch (error) {
    console.log("error", error);
    toast.error("An error occurred during download", {
      className: "errorToast",
    });
  }
  dispatch(setLoader(false));
};

export const fetchReportStats = (params) => async (dispatch) => {
  try {
    const result = await Api.fetchClientDashboardReportStats(params)
    if (result?.status >= 200 && result?.status < 300) {
      dispatch(setReportStats(result.data.data));
    }
  } catch (error) {
    console.log("error", error)
  }
}

export const fetchVendorReliability = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {
    const result = await Api.fetchClientDashboardVendorReliability(page, params)
    if (result?.status >= 200 && result?.status < 300) {
      dispatch(setVendorReliability(result.data.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
      toast.error(result?.data?.message || "Date range cannot exceed 3 months.", { className: "errorToast" })
    }
  } catch (error) {
    console.log("error", error)
  }
  !disableLoader && dispatch(setLoader(false))
}

export const downloadVendorReliabilityCSV = (params) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const response = await Api.exportVendorReliability(params);
    if (response.status >= 200 && response.status < 300) {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `vendor_reliability_${new Date().toISOString().split("T")[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      toast.success("Report Downloaded Successfully", { className: "successToast" });
    } else {
      toast.error("Failed to download report", { className: "errorToast" });
    }
  } catch (error) {
    console.log("error", error);
    toast.error("An error occurred during download", { className: "errorToast" });
  }
  dispatch(setLoader(false));
};

export const { setDashboardAnalytics, clearAllDashboard, setLoader, setError, setDashboardAppointments, setReportStats, setVendorReliability, setDashboardFilters } = dashboardSlice.actions

export default dashboardSlice.reducer
export const DashboardSelector = state => state.dashboard



